module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp23_9006.99d8de5e.png";